export interface IErrorMessages {
  [key: string]: string;
}

export const errorMessages: IErrorMessages = {
  required: 'This field is required',
  noTemplateAdded: 'No templates added',
  isLanguageSelected: 'Repeated language, please verify added languages',
  repeated: 'Repeated languages, please verify added languages',
  isEnglishNoAdded: '1. English language is required',
};
